import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

function FloatingCTA({ triggerId = "trigger-floating-cta" }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById(triggerId);

    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.15,
      }
    );

    observer.observe(target);

    return () => observer.disconnect();
  }, [triggerId]);

  const handleClick = () => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      source: "floating_cta",
    });

    window.open(
      "https://wa.me/5511996064416?text=Quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20banho%20de%20ouro%20para%20semijoias",
      "_blank"
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 9999,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0px)" : "translateY(16px)",
        pointerEvents: isVisible ? "auto" : "none",
        transition: "opacity 0.35s ease, transform 0.35s ease",
      }}
    >
      <Button
        type="primary"
        size="large"
        icon={<WhatsAppOutlined />}
        onClick={handleClick}
        style={{
          height: 54,
          borderRadius: 999,
          padding: "0 22px",
          background: "#25D366",
          borderColor: "#25D366",
          fontWeight: 700,
          boxShadow: "0 14px 30px rgba(37, 211, 102, 0.32)",
        }}
      >
        Falar no WhatsApp
      </Button>
    </div>
  );
}

export default FloatingCTA;